import { Contact } from "@/@types";
import ContactUsElement from "./ContactUsElement";

type Props = {
  contact?: Contact;
};

const DefaultContact = {
    phone: "800 22 MATCO",
    email: "info@matco.com.mx",
    schedule: "8:00am-6:00pm",
    facebook: "#",
    linkedin: "#",
    youtube: "#",
    instagram: "#",
};

const ContactUsCard = ({ contact }: Props) => {
    const phone = contact?.phone || DefaultContact.phone;
    const email = contact?.email || DefaultContact.email; 

    return (
        <div  className="mt-16 max-w-sm mx-auto">
            <p className="mb-6 text-lg text-gray03">
            Si deseas contactarnos por distintos medios, ponemos a tu disposición la siguiente información:
            </p>
            <ContactUsElement title="LLÁMANOS" content={phone} href={`tel:+52${phone.replace(/\s+/g, "")}`} src="/images/icons/yellow-phone.svg"/>
            <ContactUsElement title="ESCRÍBENOS" content={email} href={`mailto:${email}`} src="/images/icons/yellow-mail.svg"/>

        </div>
    )
}

export default ContactUsCard